import { render, staticRenderFns } from "./Ussd.vue?vue&type=template&id=2e946e4c&scoped=true&lang=html&"
import script from "./Ussd.vue?vue&type=script&lang=js&"
export * from "./Ussd.vue?vue&type=script&lang=js&"
import style0 from "./Ussd.vue?vue&type=style&index=0&id=2e946e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e946e4c",
  null
  
)

export default component.exports